import React from 'react';
import { RiFileCopyLine } from 'react-icons/ri';
import { Wrapper, Header, Footer } from '../../general_components/forms/Form';
import { priceOnFinish } from '../../supplementary_components/priceInputDelegate';
import { addNotification, popupComponents$ } from '../../supplementary_components/store';
import styles from './issueMoneyCodeIssuedPopup.module.scss';

export const ISSUE_MONEY_CODE_ISSUED_POPUP_KIND = 'issueMoneyCodeIssued';
const ISSUE_MONEY_CODE_FORM_NAME = 'issueMoneyCodeForm';

function copyMoneyCode(code) {
    const text = code != null ? String(code).trim() : '';
    if (!text) return;
    navigator.clipboard.writeText(text).then(() => {
        addNotification({ message: 'Copied to clipboard', type: 'notify', duration: 1000 });
    });
}

export function IssueMoneyCodeIssuedPopup({ closePopup, popupData }) {
    const efsCode =
        popupData?.efsCode != null && String(popupData.efsCode).trim() !== ''
            ? String(popupData.efsCode)
            : '-';
    const amountLabel =
        popupData?.amount != null && Number.isFinite(Number(popupData.amount))
            ? priceOnFinish(popupData.amount)
            : '-';

    return (
        <div className={styles.issuedRoot} onClick={(e) => e.stopPropagation()}>
            <Wrapper style={{ width: '100%', maxWidth: '100%' }}>
                <Header>
                    <span>Money Code Issued</span>
                </Header>
                <div className={styles.issuedContent}>
                    <div className={styles.detailRow}>
                        <span className={styles.label}>Money Code:</span>
                        <span className={styles.value}>{efsCode}</span>
                        {efsCode !== '-' ? (
                            <RiFileCopyLine
                                className={styles.copyButton}
                                title="Copy money code"
                                onClick={() => copyMoneyCode(efsCode)}
                            />
                        ) : null}
                    </div>
                    <div className={styles.detailRow}>
                        <span className={styles.label}>Amount:</span>
                        <span className={styles.value}>{amountLabel}</span>
                    </div>
                </div>
                <Footer>
                    <div className="non-selectable" onClick={() => closePopup()}>
                        Close
                    </div>
                </Footer>
            </Wrapper>
        </div>
    );
}

export function openIssueMoneyCodeIssuedPopup({ efsCode, amount }) {
    const withoutExisting = popupComponents$.getValue().filter(
        (popup) => popup.popupData?.popupKind !== ISSUE_MONEY_CODE_ISSUED_POPUP_KIND,
    );
    popupComponents$.next([
        ...withoutExisting,
        {
            content: IssueMoneyCodeIssuedPopup,
            popupData: {
                popupKind: ISSUE_MONEY_CODE_ISSUED_POPUP_KIND,
                efsCode,
                amount,
            },
            EZCloseAllowed: true,
            customMaxWidth: '32rem',
            customWidth: '100%',
        },
    ]);
}

export function createIssueMoneyCodePostSuccessAction(onIssued) {
    return (value) => {
        if (onIssued) {
            onIssued(value);
        }

        popupComponents$.next(
            popupComponents$.getValue().filter(
                (popup) => popup.popupData?.configuration?.name !== ISSUE_MONEY_CODE_FORM_NAME,
            ),
        );

        openIssueMoneyCodeIssuedPopup({
            efsCode: value?.efsCode,
            amount: value?.amount,
        });
    };
}
